import { useQuery } from '@tanstack/react-query';

import { useProfile } from 'context/profile';
import { indexGroups } from 'services/api/group';

export default function usePrefetchGroups(groupTypeApiName: string) {
  const { profile } = useProfile();

  const groupType = profile.actingClient.groupTypes.find((gt) => gt.apiName === groupTypeApiName);
  const groupParams = { clientId: profile.actingClient.id, groupType: groupType?.id, sortBy: 'name asc' };

  const query = useQuery({
    queryKey: ['groups', 'prefetch', groupParams],
    queryFn: ({ signal }) => indexGroups({ ...groupParams, pageSize: 1 }, signal),
  });

  return { groupType, groupParams, query };
}
